var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container-icon"},_vm._l((_vm.iconClass),function(icon,index){return _c('i',{key:index,class:icon})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }